import * as React from "react";

function JobDescription(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 27 27" fill="none" {...props}>
      <path
        d="M10.749 15.194c0-.414 0-.62.045-.79.124-.46.483-.82.943-.943.17-.045.377-.045.79-.045h1.778c.413 0 .62 0 .79.045.46.124.819.483.942.943.045.17.045.377.045.79v.889a2.667 2.667 0 01-5.333 0v-.89z"
        stroke="#333"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.949 15.415h1.577c1.712 0 2.568 0 3.297-.154 2.11-.447 3.831-1.818 4.585-3.652.26-.633.366-1.4.578-2.933.08-.575.12-.863.082-1.098-.112-.686-.661-1.247-1.402-1.432-.254-.064-.575-.064-1.218-.064H3.383c-.643 0-.964 0-1.218.064-.74.185-1.29.746-1.401 1.432-.039.235.001.523.081 1.098.212 1.533.319 2.3.579 2.933.753 1.834 2.474 3.205 4.584 3.652.73.154 1.585.154 3.298.154h1.576"
        stroke="#333"
        strokeWidth={1.5}
      />
      <path
        d="M2.083 12.75v2.667c0 5.028 0 7.542 1.475 9.104 1.476 1.562 3.85 1.562 8.6 1.562h2.518c4.749 0 7.123 0 8.598-1.562 1.476-1.562 1.476-4.076 1.476-9.104V12.75"
        stroke="#333"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.082 6.083l-.103-.47c-.513-2.347-.77-3.52-1.38-4.192C15.986.75 15.174.75 13.551.75h-.273c-1.623 0-2.435 0-3.046.671-.61.671-.868 1.845-1.381 4.191l-.103.471"
        stroke="#333"
        strokeWidth={1.5}
      />
    </svg>
  );
}

export default JobDescription;
